import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { MutateInlineInfoDTO } from "../../dto";

type CreateInlineInfoProps = {
  lineId: number;
  name: string;
  text: string;
};

let body: MutateInlineInfoDTO;

export async function createInlineInfoAction(props: CreateInlineInfoProps) {
  const token = localStorage.getItem("token");

  const params = {
    linesOfPoetriesId: props.lineId,
    name: props.name,
    text: props.text,
  };

  return await axios
    .post(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/inline-infos/create`,
      params,
      {
        headers: {
          "Content-Type": "application/json",
          "app-platform": "cms",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(async (res) => {
      body = plainToClass(MutateInlineInfoDTO, res.data);
      const errors = await validate(body);

      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
